import { useState } from "react";
import { ApsAsidePlaceholder, ApsDescriptionCard, ApsDescriptionCardHeader, ApsHybridTrayToAside } from "UserExperience/portal-vnext";

const UploadOption = ({uploadOption, name, description, selectText, beginText, optionClosed, startUpload}) => {

  const [openTrayUploadCategoryHidden, setOpenTrayUploadCategoryHidden] = useState(false);
 
  const headerCtaClicked = () => {
    setOpenTrayUploadCategoryHidden(true);
    startUpload();
  };

  return (
    <ApsHybridTrayToAside
      id="start-page-hybrid-tray"
      isTrayOpen={uploadOption}
      isTrayHidden={openTrayUploadCategoryHidden}
      role="complementary"
    >
      <ApsAsidePlaceholder
        placeholderText={selectText}
        show={!uploadOption}
      />
      <ApsDescriptionCard show={uploadOption}>
        <ApsDescriptionCardHeader
          headerTitle={name}
          headerCopy={description}
          headerCta={beginText}
          headerCtaClick={headerCtaClicked}
          headerCloseClick={optionClosed}
        />
      </ApsDescriptionCard>
    </ApsHybridTrayToAside>
  );
};

export default UploadOption;